import React, { useContext, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router'
import { doSignOut } from '../Firebase/firebaseConfig'
import { LOGIN } from '../../constants/routes'
import { FirestoreContext } from '../Firebase/firestoreContext'
import { doc, deleteDoc } from 'firebase/firestore'
import { AuthContext } from '../Firebase/firebaseContext'

const Logout = () => {
  const navigate = useNavigate()
  const { user } = useContext(AuthContext)
  const { firestore } = useContext(FirestoreContext)
  const signOutStarted = useRef(false)

  // Don't write useEffect(async () => ...) otherwise the component will crash.
  // If you need to await inside useEffect() do it in the following way.
  useEffect(() => {
    // user and firestore arrive from context asynchronously; without this guard
    // reading user.uid below throws and the user is never signed out.
    if (!user || !firestore || signOutStarted.current) {
      return
    }
    signOutStarted.current = true

    const signout = async () => {
      const sessionId = localStorage.getItem('sessionId')
      localStorage.removeItem('sessionId')

      // Tidying up the session record is best effort. Whether or not there is a
      // sessionId, and whether or not the delete succeeds, we must still sign
      // the user out and send them to the login page.
      if (sessionId) {
        try {
          console.log(`Deleting users/${user.uid}/user_sessions/${sessionId} ...`)
          await deleteDoc(doc(firestore, `users/${user.uid}/user_sessions/${sessionId}`))
        } catch (reason) {
          console.error(reason)
        }
      }

      const result = await doSignOut()
      if (!result || !result.success) {
        console.error('Sign out failed', result && result.details)
      }
      navigate(LOGIN)
    }

    signout()
  }, [firestore, navigate, user])
  return <></>
}

export default Logout
